import { cn } from "@/lib/cn"
import { toneCss } from "../format"
import type { Tone } from "../types"

type Props = {
  value: { label: string; tone?: Tone } | null | undefined
}

// Inline pill — used inside table rows to render ban-state, status,
// fraud-flag chips. Tone always paired with a dot so colorblind users
// see the meaning, not just the hue.
export function BadgeCell({ value }: Props) {
  if (!value || typeof value !== "object" || !value.label) {
    return <span className="text-app-subtle">—</span>
  }
  const css = toneCss(value.tone)
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1 rounded-chip border px-1.5 py-0.5 text-[11px] font-medium",
        css.text,
        css.bg,
        css.border,
      )}
    >
      <span className={cn("h-1.5 w-1.5 rounded-full", css.dot)} aria-hidden="true" />
      {value.label}
    </span>
  )
}
